/**
 * Os tokens do LAYOUT OFICIAL do DUE — o aprovado em 03/10/2026, cujas
 * referências estão em `modules/docs/enterprise/design-references/due-home-approved/`.
 *
 * ESTE ARQUIVO EXISTE EM DOIS LUGARES, BYTE A BYTE IGUAIS:
 *
 *   - modules/platform/app-shared/layoutOficial.js   (canônico)
 *   - modules/eia/app/src/utils/layoutOficial.js     (cópia obrigatória)
 *
 * A cópia existe porque o app do eia é Create React App sem craco, e o
 * `ModuleScopePlugin` recusa import de fora de `src/`. A divergência é pega
 * pelo teste `layout-oficial.test.mjs`, que compara os dois caractere a
 * caractere — mesmo arranjo do avatar por viseme.
 *
 * POR QUE ISTO NASCEU, em 04/10/2026. O layout oficial estava implementado e
 * publicado, mas os VALORES dele viviam escritos à mão dentro dos SFC do `front`
 * e do `due-empresa` — `#173957` repetido, `Georgia` repetido, o creme repetido.
 * Não havia fonte única: quem fosse adaptar um terceiro app, como o canal de
 * denúncia, só podia copiar hexadecimal de outra tela e torcer. É a mesma
 * origem da divergência que o `themeTokens.js` documenta para os presets de
 * cliente, e a resposta é a mesma: escrever os valores num lugar só.
 *
 * ⚠️ NÃO CONFUNDA COM `themeTokens.js`. Aquele é o catálogo WHITE-LABEL: as
 * cores que mudam por cliente contratante (o azul da Câmara, o dourado do
 * brasão). Este é a identidade do PRODUTO DUE, que não muda por cliente — é a
 * moldura, não o conteúdo.
 *
 * RISCO CONHECIDO, herdado: nenhum destes valores foi auditado para modo
 * escuro. Todos assumem fundo claro.
 */

export const CORES = {
  /** Azul-marinho da marca: títulos, texto e botão de ação. */
  tinta: '#173957',
  /** O mesmo azul, um grau mais fundo, para o botão primário. */
  acao: '#173b59',
  /** Fundo da página: creme, nunca branco puro. */
  papel: '#fbf5eb',
  /** Cartão e campos sobre o creme. */
  superficie: '#fffdf8',
  /** Fundo de apoio, um degrau abaixo da superfície. */
  apoio: '#fbfaf7',
  /** Linha de contorno de cartão, campo e divisória. */
  borda: '#e7e6df',
  /** Texto secundário. Mede 4,6:1 sobre a superfície. */
  apagado: '#66737a',
  /** Texto terciário, para legenda e rótulo pequeno. */
  tenue: '#8a97a0',
  /** Faixa de aviso, e a barra que a marca. */
  avisoFundo: '#fbf0e5',
  avisoBarra: '#8a5b0d',
};

export const TIPOGRAFIA = {
  /** Display: serifa. É o traço mais reconhecível do layout oficial. */
  titulo: "Georgia, 'Times New Roman', serif",
  /** Interface e corpo. */
  corpo: 'Arial, Helvetica, sans-serif',
};

export const FORMA = {
  raioCartao: '10px',
  raioBotao: '8px',
  raioCampo: '7px',
  /** Altura da barra superior nos apps Vue; vale como referência de ritmo. */
  alturaBarra: '64px',
  /** Largura máxima de conteúdo corrido. */
  larguraTexto: '1140px',
};
